import Navigation from 'Components/Navigation'
import React, { useState, useEffect } from 'react'
import No from '../../Assets/Images/Login/no.svg'
import {
  SERVICE_MATERIALS_CALCULATOR,
  MATERIALS_CALCULATOR_CEILING_PARAM,
} from 'Utils/constants'
import MiniLoading from 'Components/MiniLoading'
import { useHistory, useLocation } from 'react-router-dom'
import './materialsCalculator.css'
import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'
import { useSelector } from 'react-redux'

export default function MaterialsCalculator() {
  const history = useHistory()
  const location = useLocation()
  const calculatorParam = new URLSearchParams(location.search).get('calculator')
  const [iframeLoaded, setIframeLoaded] = useState(false)
  const [iframeError, setIframeError] = useState(false)

  const isPageLoading = !iframeLoaded

  const { CompanyId, WarehouseId } = useSelector(state => state.company)
  const { CustomerId } = useSelector(state => state.login.user?.CustomerInfo)

  useEffect(() => {
    let timeout

    fetch(SERVICE_MATERIALS_CALCULATOR, { method: 'HEAD', mode: 'no-cors' })
      .then(() => {
        timeout = setTimeout(() => {
          if (!iframeLoaded) setIframeError(true)
        }, 60000)
      })
      .catch(() => {
        setIframeError(true)
      })

    return () => clearTimeout(timeout)
  }, [iframeLoaded])

  return (
    <>
      <Navigation />
      <div className="calculator_service_request">
        <div className="container-header-materials-calculator">
          <h1>Calculadora de materiales</h1>
          <img src={No} onClick={() => history.goBack()} />
        </div>
        {isPageLoading && <MiniLoading full={true} noMargin={true} />}
        <div
          className="iframe-calculator-container"
          style={{ display: iframeLoaded && !iframeError ? 'block' : 'none' }}>
          <iframe
            src={
              calculatorParam
                ? `${SERVICE_MATERIALS_CALCULATOR}?${MATERIALS_CALCULATOR_CEILING_PARAM}&company_id=${CompanyId}&warehouse_id=${WarehouseId}&sales_agent_id=${CustomerId}`
                : `${SERVICE_MATERIALS_CALCULATOR}?company_id=${CompanyId}&warehouse_id=${WarehouseId}&sales_agent_id=${CustomerId}`
            }
            className="iframe-calculator-element"
            title="Service Materials Calculator"
            onLoad={() => setIframeLoaded(true)}
          />
        </div>
        <ModalAlertGeneric
          isError={iframeError}
          setIsError={setIframeError}
          messageSettings={{
            message: 'MATERIALS_CALCULATOR_MESSAGE_ERROR',
            status: 'error',
          }}
          setMessageSettings={() => {}}
        />
      </div>
    </>
  )
}
